import Box from "@mui/material/Box";
import { useMemo } from "react";
import { Outlet } from "react-router-dom";
import TabMenu from "../../components/TabMenu.js";

export default function Security({ locales }) {
  const tabButtons = useMemo(
    () => [
      { label: locales["security.hosts.title"], route: "hosts" },
      { label: locales["security.employees.title"], route: "employees" },
    ],
    [locales]
  );

  return (
    <>
      <TabMenu tabButtons={tabButtons} />
      <Box>
        <Outlet />
      </Box>
    </>
  );
}
